


////// LIQUID HOVER EFFECT /////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////

new hoverEffect({
    parent: document.querySelector('.about__img_dist'),
    intensity: 0.2,
    image1: '../img/emi.png',
    image2: '../img/city.png',
    displacementImage: '../img/smoke.png'
});

new hoverEffect({
    parent: document.querySelector('.distortion2'),
    intensity: 0.2,
    image1: '../img/porsche2.jpg',
    image2: '../img/porsche1.jpg',
    displacementImage: '../img/smoke.png'
});

new hoverEffect({
    parent: document.querySelector('.distortion3'),
    intensity: 0.2,
    image1: '../img/audiRS6.png',
    image2: '../img/488.jpg',
    displacementImage: '../img/smoke.png'
});

// new hoverEffect({
//     parent: document.querySelector('#cta1_header_button'),
//     intensity: 0.7,
//     image1: '../img/gradient_bg_3.png',
//     image2: '../img/gradient_bg_4.png',
//     displacementImage: '../img/smoke.png'
// });

// new hoverEffect({
//     parent: document.querySelector('#latest_works_img1'),
//     intensity: 0.2,
//     image1: '../img/ducati.png',
//     image2: '../img/ducati2.png',
//     displacementImage: '../img/smoke.png'
// });
// new hoverEffect({
//     parent: document.querySelector('#latest_works_img2'),
//     intensity: 0.2,
//     image1: '../img/ducati.png',
//     image2: '../img/ducati2.png',
//     displacementImage: '../img/fluid.jpg'
// });


/////////////////////////////////////////////////////////////////////////////////////////
//////////////   GSAP   ANIMATIONS    ///////////////////////////////////////////////////

